var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as _ from "lodash";
import { components } from "react-select";
import { ImgThemeConsumer } from "../theme/ThemeHelpers";
import ImgSelect from "./ImgSelect";
import Flag from "./Flag";
import { appendPx, scaleSize } from "../theme/DefaultTheme";
var LanguageOption = function (size, margin, padding) { return function (props) {
    var data = props.data;
    return (React.createElement(components.Option, __assign({}, props),
        _.map(data.flags, function (f) { return React.createElement("span", { style: { marginLeft: 4 }, key: f },
            React.createElement(Flag, { marginTop: margin, paddingTop: padding, size: size, name: f })); }),
        React.createElement("span", { style: { marginLeft: 10 } }, data.label)));
}; };
var LanguageValue = function (size, margin, padding) { return function (props) {
    var data = props.data;
    return (React.createElement("div", null,
        _.map(data.flags, function (f) { return React.createElement(Flag, { marginTop: margin, paddingTop: padding, size: size, name: f, key: f }); }),
        React.createElement("span", { style: { marginLeft: 10 } }, data.label)));
}; };
var LanguageSelect = function (props) {
    var lngs = _.map(props.languageList, function (l) {
        var _a;
        var split = l.split("-");
        var lng = split[0].toUpperCase();
        var co = (_a = split[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        return { value: l, label: props.translationFunction ? props.translationFunction(lng) : lng, flags: co ? [co] : [] };
    });
    var innerval = _.find(lngs, function (l) { return l.value === props.value; });
    return (React.createElement(ImgThemeConsumer, null, function (theme) { return (React.createElement(ImgSelect, { value: innerval, options: lngs, components: {
            Option: LanguageOption(theme.iconSize, "calc(" + appendPx(scaleSize(theme.iconSize, 0.5)) + " - 16px)", "calc(16px - " + appendPx(scaleSize(theme.iconSize, 0.5)) + ")"),
            SingleValue: LanguageValue(theme.iconSize, "calc(" + appendPx(scaleSize(theme.iconSize, 0.5)) + " - 16px)", "calc(16px - " + appendPx(scaleSize(theme.iconSize, 0.5)) + ")")
        }, onChange: props.onChange, isClearable: props.isClearable })); }));
};
export default LanguageSelect;
//# sourceMappingURL=LanguageSelect.js.map